<template>
  <div>
    <!-- Page Header -->
    <div class="page-header-modern">
      <div class="page-header-inner">
        <h2 class="font-28">Berita</h2>
        <div class="breadcrumb-modern">
          <a href="/">Home</a>
          <span>/</span>
          <span class="bc-active">Berita</span>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="container-standar" style="padding-top: 56px; padding-bottom: 80px;">

      <!-- News Grid -->
      <div class="news-grid">
        <a
          v-for="(berita, index) in news"
          :key="index"
          :href="'/berita/' + berita.slug"
          class="news-card"
        >
          <div class="news-card-img-wrap">
            <img :src="berita.picture_path" :alt="berita.title" />
            <span class="news-card-category">Berita</span>
          </div>
          <div class="news-card-body">
            <div class="news-card-meta">
              <b-icon icon="calendar3" font-scale="0.75" style="color: var(--text-light);"></b-icon>
              <span class="meta-date">{{ berita.created }}</span>
            </div>
            <h3 class="news-card-title">{{ berita.title | shotDescription(80) }}</h3>
            <p class="news-card-excerpt">{{ berita.content | shotDescription(120) }}</p>
            <div class="news-card-author">
              <img class="author-avatar" src="@/assets/images/avatar.png" alt="Admin" />
              <span class="author-name">Admin</span>
            </div>
          </div>
        </a>
      </div>

      <!-- Empty State -->
      <div v-if="news.length === 0" class="text-center" style="padding: 80px 0;">
        <b-icon icon="newspaper" font-scale="4" style="color: var(--border);"></b-icon>
        <p style="margin-top: 20px; color: var(--text-muted); font-size: 16px;">Belum ada berita</p>
      </div>

      <!-- See More Button -->
      <div
        v-if="news.length !== allnews.length"
        class="text-center"
        style="margin-top: 56px;"
      >
        <span class="see-more-btn" @click="news = allnews">
          <b-icon icon="grid" font-scale="0.9"></b-icon>
          Lihat Semua Berita
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      news: [],
      allnews: [],
    };
  },
  mounted() {
    this.getBerita();
  },
  methods: {
    getBerita() {
      this.$axios.get("/news").then((response) => {
        this.allnews = response.data.data;
        this.news = response.data.data.filter((_, index) => index < 6);
      });
    },
  },
};
</script>
